import {createAction} from 'web-app/util/redux/typed-action-helpers';

type Seconds = number;
/**
 * Calling this action will result in the session being extended.
 * This is mostly used internally in auto-logout's epics, although
 * there are cases in the app where this is called manually such as
 * the "scan documents" feature when opening the camera.
 */
export const {action: extendSession} = createAction('SESSION_ACTIONS/EXTEND_SESSION', () => ({}));

/**
 * An action indicating that the session has been extended. Used internally
 * by auto-logout's epics, test coverage, and the debugging overlay
 */
export const {action: extendSessionSuccess} = createAction(
    'SESSION_ACTIONS/EXTEND_SESSION_SUCCESS',
    (secondsToExpiration: Seconds) => ({secondsToExpiration}),
);

/**
 * When "close" to expiration, i.e. T minus 30 seconds, this action will start being emitted
 * once every second. This is picked up by the warning/dialog that opens to tell users
 * about the imminent automatic logout.
 */
export const {action: updateExpirationStatus} = createAction(
    'SESSION_ACTIONS/EXPIRATION_STATUS',
    (payload: {status: 'close-to-expiration'; secondsToExpiration: number} | {status: 'idle'}) => payload,
);

/**
 * This is the last action emitted by auto-logout's epics. When this is emitted it is
 * picked up be another epic which runs a side-effect causing the user to be logged out,
 * and the page to be reloaded back to the login route.
 */
export const {action: logout} = createAction('SESSION_ACTIONS/LOG_OUT', () => ({}));
